import PhotographersGrid from "./components/PhotographersGrid/PhotographersGrid";

export default function Home() {
  return (
    <>
      <PhotographersGrid />
    </>
  );
}
